@import '~style-sheet-helpers/core.less';
@import '../../../app-brand/entities/entity-layer.module.less';

.currency-input {
  position: relative;
  display: flex;
  align-items: center;
  background: @currency-input--background-color;
  height: 42px;
  border-radius: 4px;
  border: 1px solid @currency-input--border-color;

  &.disabled {
    background-color: @currency-input--disabled--background-color;
    border-color: @currency-input--disabled--border-color;
  }

  &.focused,
  &:hover {
    border-color: @currency-input--focus--border-color;
  }

  input {
    width: 100%;
    height: 100%;
    border: none;
    resize: none;
    background: transparent;
    padding: 0 10px;
    color: @currency-input--text-color;
    line-height: 20px;
    font-size: 14px;
    text-align: right;
  }

  input:focus {
    border-color: @currency-input--focus--border-color;
  }

  &.symbol-right {
    flex-direction: row-reverse;
    input {
      padding: 0 25px 0 10px;
    }
    .currency {
      padding: 2px 10px 0 0;
    }
  }
}

.currency {
  color: @currency-input--text-color;
  padding: 2px 0 0 10px;
  z-index: 1;
}
